<template>
  <v-footer v-if="!isMobile()" color="primary" padless dense app width="100%">
    <v-row justify="center" no-gutters>
      <v-col cols="12" sm="auto" class="text-center">
        <p style="color: whitesmoke; margin-right: 10px">
          © Copyright 2026 www.themathboard.com
        </p>
      </v-col>
      <v-col cols="12" sm="auto" class="text-center">
        <v-btn
          style="background-color: transparent; color: whitesmoke"
          class="ml-1"
          height="25"
          flat
          href="/privacyPolicy.html"
          target="_blank"
        >
          {{ shell.privacy }}
        </v-btn>

        <v-btn
          style="background-color: transparent; color: whitesmoke"
          class="ml-1"
          height="25"
          flat
          @click="emit('show-contact-us')"
        >
          {{ shell.contact }}
        </v-btn>

        <a
          v-if="showTopicsLink"
          class="footer-topics"
          :href="topicsHref"
          data-cy="footer-topics"
        >
          {{ topicsLabel }}
        </a>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import { isMobile } from "common/globals";
import { usePracticeLocale } from "../composables/usePracticeLocale";
import { shellUi } from "../i18n/practiceCopy";
import { mathHubPath } from "../seo/topicPages";

const emit = defineEmits<{
  "show-contact-us": [];
}>();

const route = useRoute();
const { isHebrew } = usePracticeLocale();
const shell = computed(() => shellUi(isHebrew.value));
const topicsLang = computed<"en" | "he">(() =>
  route.path.startsWith("/he/") ? "he" : "en",
);
const topicsHref = computed(() => mathHubPath(topicsLang.value));
const topicsLabel = computed(() =>
  topicsLang.value === "he" ? "נושאי מתמטיקה" : "Math topics",
);
const showTopicsLink = computed(() => route.path !== topicsHref.value);
</script>

<style scoped>
.footer-topics {
  color: whitesmoke;
  margin-left: 8px;
  font-size: 0.875rem;
  text-decoration: none;
}
</style>
